export const Error = {
  Summary:
    "Something went wrong trying to load the Request of Processing Activity. Please try again later.",
};
